import Vue from "vue";
// 统一弹窗和独立页面的问卷步骤操作按钮
export default Vue.extend({
  name: "QuestionnaireEditorActions",
  props: {
    activeIndex: {
      type: Number,
      default: 1
    },
    isAnswerMode: {
      type: Boolean,
      default: false
    },
    isViewMode: {
      type: Boolean,
      default: false
    },
    editSpecialMode: {
      type: Boolean,
      default: false
    },
    surveyType: {
      type: String,
      default: "NORMAL"
    },
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isFinalStep() {
      return this.activeIndex == (this.isAnswerMode ? 3 : 2);
    }
  }
});